import React, { Component } from "react";
import Header from "./containers/Header";
import Main from "./containers/Main";
import Footer from "./containers/Footer";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import Spinner from "./containers/Spinner";
import "./App.css";
import SearchContainer from "./features/Search/SearchContainer";
import { getData } from "./features/Search/data";
class App extends Component {
  state = { main: true, search: false, spinner: false };
  componentWillMount = async () => {};
  getSearchResults = async name => {
    if (name.length < 1) {
      this.setState({ main: true, spinner: false, search: false });
    } else if (name.length % 2 === 0) {
      //starting search
      this.setState({ main: false, spinner: true, search: false });
      let response = await getData(name);
      //search finished
      this.setState({
        main: false,
        spinner: false,
        search: true,
        data: response
      });
    }
  };
  getMainContent = () => {
    if (this.state.spinner) {
      return <Spinner />;
    }
    if (this.state.main) {
      return <Main />;
    }
    if (this.state.search) {
      return <SearchContainer data={this.state.data} />;
    }
  };
  render() {
    return (
      <Router history={createBrowserHistory()}>
        <div className="app">
          <div className="header-container">
            <Header search={this.getSearchResults} />
          </div>
          <div className="main-container">{this.getMainContent()}</div>
          <div className="footer-container">
            <Footer />
          </div>
        </div>
      </Router>
    );
  }
}

export default App;
